import { Amplify, type ResourcesConfig } from 'aws-amplify';
export const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolId: String(import.meta.env.VITE_POOL_ID),
    userPoolClientId: String(import.meta.env.VITE_COGNITO_APP_CLIENT_ID),
  },
};

Amplify.configure(
  {
    Auth: authConfig,
  },
  { ssr: true },
);

export default function ConfigureAmplifyClientSide() {
  return null;
}
